module.exports = {
  title: '数据字典',
  route: {
    path: '/crm-system',
    children: {
      path: 'crm-data-dictionary',
    },
  },
};
